import React, { useState, useEffect } from 'react';

// Material-ui
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import CircularProgress from '@material-ui/core/CircularProgress';

import { postbwloyverse } from './_api/api';

const useStyles = makeStyles(theme => ({
    container: {
        [theme.breakpoints.up('xs')]: {
            minWidth: '440px',
            width: '440px',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    root: {
        marginTop: theme.spacing(12),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    logoImg: {
        height: '40px',
        margin: theme.spacing(3, 0, 2),
    },
    errormsg: {
        backgroundColor: theme.palette.error.main,
        minWidth: '288px',
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
    successfullMessage: {
        textAlign: 'center',
    } 
}));

const Success = (props) => {
    const classes = useStyles();
    const query = new URLSearchParams(props.location.search)
    const code = query.get('code');
    const stateparam = query.get('state');
    const [state, setState] = useState({
        fetching: false,
        fetched: false,
        fetchError: false,
        message: null
    });

    useEffect(() => {
        const connectaccounts = async () => {
            setState(prevState => { return { ...prevState, fetching: true, fetchError: false, message: null } })

            const bwloyversepayload = {
                "AuthorizationCode": code,
                "Hash": stateparam
            }


            postbwloyverse(`/connect-accounts`, bwloyversepayload)
                .then(response => {
                    if (response)
                        setState(prevState => { return { ...prevState, fetching: false, fetched: true } });
                    else
                        setState(prevState => { return { ...prevState, fetching: false, fetchError: true, message: 'Internal Server Error' } });
                })
                .catch(error => setState(prevState => { return { ...prevState, fetching: false, fetchError: true, message: error.message } }));
        };

        connectaccounts();
    }, [code, stateparam]);

    if (state.fetching)
        return (
            <Container className={classes.container}>
                <div className={classes.root}>
                    <img className={classes.logo} alt='BrandWallet Logo' src='assets/img/bw-logo-color-250x50.png' />
                    <br />
                    <Typography variant='h6'>Connecting your accounts...</Typography>
                    <br />
                    <CircularProgress />
                </div>
            </ Container>
        );

    if (state.fetched)
        return (
            <Container className={classes.container}>
                <div className={classes.root}>
                    <img className={classes.logo} alt='BrandWallet Logo' src='assets/img/bw-logo-color-250x50.png' />
                    <br />
                    <Typography className={classes.successfullMessage} variant='h6'>Your BrandWallet and Loyverse accounts are connected successfully!</Typography>
                    <br />
                    <Typography variant='h6'>Enjoy :)</Typography>
                </div>
            </ Container>
        );

    if (state.fetchError)
        return (
            <Container className={classes.container}>
                <div className={classes.root}>
                    <img className={classes.logo} alt='BrandWallet Logo' src='assets/img/bw-logo-color-250x50.png' />
                    <br />
                    <Typography variant='h6'>An error occured while connecting your accounts</Typography>
                    <br />
                    <Typography variant='h6'>{state.message}</Typography>
                </div>
            </ Container>
        );

    return ('');
}

export default Success